export const ReceiptEditIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="vuesax/linear/receipt-edit">
      <path
        id="Vector"
        d="M13.6668 7.53398V4.69399C13.6668 2.00732 13.0402 1.33398 10.5202 1.33398H5.48016C2.96016 1.33398 2.3335 2.00732 2.3335 4.69399V12.2006C2.3335 13.974 3.30684 14.394 4.48684 13.1273L4.49349 13.1206C5.04016 12.5406 5.87349 12.5873 6.34682 13.2206L7.02016 14.1206"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M5.3335 4.66602H10.6668"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M6 7.33398H10"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Group">
        <path
          id="Vector_4"
          d="M12.1405 9.84685L9.78052 12.2069C9.68719 12.3002 9.60051 12.4735 9.58051 12.6002L9.45384 13.5002C9.40718 13.8269 9.63385 14.0535 9.96052 14.0069L10.8605 13.8802C10.9872 13.8602 11.1672 13.7735 11.2539 13.6802L13.6139 11.3202C14.0205 10.9135 14.2139 10.4402 13.6139 9.8402C13.0205 9.24686 12.5472 9.44018 12.1405 9.84685Z"
          stroke={strokeColor}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M11.7993 10.1875C11.9993 10.9075 12.5593 11.4675 13.2793 11.6675"
          stroke={strokeColor}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
